import { useMemo } from "react";
import {
  TextField,
  DatagridConfigurable,
  useTheme,
  NumberField,
} from "react-admin";
import DownloadAction from "../../components/tableListActions/DownloadActionNew";
import getFirstAndLastDateOfCurrentMonth from "../../utils/firstLastDate";
import MyDatagridBody from "../../components/common/MyDatagridBody";
import accountReceivablePcmOverviewFilterList from "../../components/accountReceivablePcmOverviews/filter/accountReceivablePcmOverviewFilterList";
import AccountReceivablePcmOverviewFooterList from "../../components/accountReceivablePcmOverviews/footer/AccountReceivablePcmOverviewFooterList";
import useCompanyScopedListFilters from "../../hooks/useCompanyScopedListFilters";
import ManualReportList from "../../components/reports/ManualReportList";

const [firstDate, lastDate] = getFirstAndLastDateOfCurrentMonth();

const AccountReceivablePcmOverviewList = () => {
  const defaultFilterValues = useMemo(
    () => ({
      start_date: firstDate,
      end_date: lastDate,
      cut_off: lastDate,
    }),
    []
  );
  const {
    canSeeCompanyColumn,
    currentCompanyFilter,
    filterDefaultValues,
  } =
    useCompanyScopedListFilters(defaultFilterValues);
  const [theme] = useTheme("light");

  const list = useMemo(
    () => (
      <ManualReportList
        key={currentCompanyFilter.company_id || "no-company"}
        storeKey={false}
        title="mine.label.account_receivable_pcm_overview"
        empty={false}
        actions={<DownloadAction />}
        filters={accountReceivablePcmOverviewFilterList}
        sort={{ field: "customers.code", order: "ASC" }}
        filterDefaultValues={filterDefaultValues}
        requiredFilters={["start_date", "end_date", "cut_off"]}
        // queryOptions={{ meta: { sort: ["customers.created_at ASC"] } }} // overide default sort
      >
        <DatagridConfigurable
          body={
            <MyDatagridBody
              footer={<AccountReceivablePcmOverviewFooterList />}
            />
          }
          bulkActionButtons={false}
          sx={{
            "& .RaDatagrid-expandedPanel > td": {
              p: 0,
              bgcolor: theme !== "dark" ? "#E7EBF0" : "grey.800",
            },
          }}
        >
          {canSeeCompanyColumn ? (
            <TextField label="mine.label.depo" source="company_alias" />
          ) : null}
          <TextField source="name" label="mine.label.customer_name" />
          <NumberField source="loan_tenor" label="mine.label.loan_tenor" />
          <NumberField source="previous_ar" label="Begining AR" />
          <NumberField source="previous_pcm" label="Begining PCM" />
          <NumberField source="days" label="mine.label.day" />
          <NumberField source="total_ar" label="Total AR" />
          <NumberField source="total_pcm" label="Total PCM" />
          <NumberField source="total_ar_pcm" label="Total AR + PCM" />
          <NumberField source="final_ar" label="Final AR" />
          <NumberField source="final_pcm" label="Final PCM" />
        </DatagridConfigurable>
      </ManualReportList>
    ),
    [
      theme,
      canSeeCompanyColumn,
      currentCompanyFilter.company_id,
      filterDefaultValues,
    ]
  );
  return list;
};

export default AccountReceivablePcmOverviewList;
